import { GetBookings } from 'src/context/utils/user/get-bookings'
import { GetUser } from 'src/context/utils/user/get-user'

export const UpdateUserData = async ( firebase, uid, setUser, setAuthUser, setCart ) => {

  const getUser = async ( uid ) => GetUser( firebase, uid )

  const getBookings = async user => GetBookings( firebase, user )
  let isRealUser = true

  try {

    const fs_user = await getUser( uid )
    setUser( fs_user )

    fs_user._id = uid
    const fs_bookings = await getBookings( fs_user )
    setCart( fs_bookings )

    localStorage.setItem( "isLoggedIn", true )

  } catch ( error ) {
    isRealUser = false
    localStorage.setItem( "isLoggedIn", false )
    setAuthUser( null )
    console.log( 'update-user-data', { error } )
  }
  return isRealUser
}

export default UpdateUserData